import { ParameterConfig } from '../../pipeline/parameter-config';
import { IViolation } from '../../base/annotation';
import { shellStringResources } from '../../../Resources/ShellStringResources';
import { sanitizeAndFormatString } from '../../../shared/utils/string.util';

export class ParameterConfigUtils {

    // eslint-disable-next-line max-len
    public static createParameterConfigurationValidator(allowNull: boolean = false, propertyName?: string, allowNullParameterType: boolean = true): (_activity?: {}, configs?: ParameterConfig[], violation?: IViolation) => IViolation[] | undefined {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (_activity?: {}, configs?: ParameterConfig[], violation?: IViolation): IViolation[] | undefined => {
            if (!configs) {
                return undefined;
            }
            if (violation && violation.context) {
                // only validate in this violation's context
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const configIndex = (violation.context as any).index;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const isKey = (violation.context as any).field === 'name';
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const isType = (violation.context as any).field === 'type';

                if (configIndex < 0 || configIndex >= configs.length) {
                    // this could happen if a header row was deleted
                    return undefined;
                }
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!(violation.context as any).duplicate) {
                    if (isKey) {
                        return !!(configs[configIndex].name) ? undefined : [violation];
                    } else if (isType) {
                        if (allowNullParameterType) {
                            return undefined;
                        } else {
                            return !!(configs[configIndex].type) ? undefined : [violation];
                        }
                    } else {
                        return !!(configs[configIndex].value) ? undefined : [violation];
                    }
                } else {
                    const keySet = new Set<string>(configs.map((item) => item.name));
                    return (keySet.size === configs.length) ? undefined : [violation];
                }
            } else {
                const keySet = new Set<string>();
                const violations = new Array<IViolation>();
                configs.forEach((config, index) => {
                    // validate name
                    if (config.name == null || config.name === '') {
                        violations.push({
                            message: () => shellStringResources.Activity_Error_Configuration_InvalidName,
                            context: {
                                field: 'name',
                                index,
                                propertyName
                            }
                        });
                    } else {
                        // only config with non-empty name will be take into account
                        if (keySet.has(config.name)) {
                            violations.push({
                                message: () => shellStringResources.ParameterConfiguration_Error_DuplicateName,
                                context: {
                                    field: 'name',
                                    index,
                                    duplicate: true,
                                    propertyName
                                }
                            });
                        }
                        keySet.add(config.name);
                    }
                    // validate value
                    if (!allowNull && (config.value == null || (config.value === '')) && ParameterConfig.VALUE.templateValue(config) === undefined) {
                        violations.push({
                            message: () => sanitizeAndFormatString(shellStringResources.Activity_Error_Configuration_InvalidValue, config?.name || ''),
                            context: {
                                field: 'value',
                                index,
                                propertyName
                            }
                        });
                    }
                    if (!allowNullParameterType) {
                        if (config.type == null) {
                            violations.push({
                                message: () => shellStringResources.Activity_Error_Configuration_InvalidType,
                                context: {
                                    field: 'type',
                                    index,
                                    propertyName
                                }
                            });
                        }
                    }
                });
                return violations.length > 0 ? violations : undefined;
            }
        };
    }
}
